(() => {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.js-open-quick-view');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      let handle = (btn.dataset.handle || '').trim();
      if (!handle) return;

      handle = handle.replace(/^\/(es|fr|en)(?=\/|$)/i, '');

      if (!handle.startsWith('/products/'))
        handle = '/products/' + handle.replace(/^\/+/, '');

      document.dispatchEvent(new CustomEvent('open_quick_view', {
        detail: {
          productHandle: handle,
          productId: btn.dataset.productId,
          position: btn.dataset.position || 'banner',
          addToCartLocation: btn.dataset.location || 'Quick View'
        }
      }));
    }, true);
})();